/**
 * @file   QuickStatsStrip.js
 * @brief  Three inline stat pills for Match tab: Active Matches, Peak Demand, Most Demand range.
 *         Only renders for Tier 1-2 (3+ matches).
 */
import React, { useMemo } from "react";
import { formatCompactPrice, computePeakDemandBin, computeSweetSpotRange } from "@/helpers/priceCapUtils";
import './quick_stats_strip.scss'

const NUM_BINS = 30;

const QuickStatsStrip = ({ matchCount, prices, adType, rangeMax }) => {
  if (!matchCount || matchCount < 3) return null;

  const peakBinIdx = useMemo(
    () => computePeakDemandBin(prices, NUM_BINS, rangeMax),
    [prices, rangeMax],
  );

  const sweetSpot = useMemo(
    () => computeSweetSpotRange(prices, adType),
    [prices, adType],
  );

  // Calculate peak demand price from bin index
  const peakPrice = peakBinIdx != null && rangeMax
    ? (peakBinIdx + 0.5) * (rangeMax / NUM_BINS)
    : null;

  return (
    <div className="quick-stats-strip">
      <div className="quick-stats-strip__pill">
        <span className="quick-stats-strip__value">{matchCount}</span>
        <span className="quick-stats-strip__label">Active Matches</span>
      </div>
      {peakPrice != null && (
        <div className="quick-stats-strip__pill">
          <span className="quick-stats-strip__value">{formatCompactPrice(peakPrice)}</span>
          <span className="quick-stats-strip__label">Peak Demand</span>
        </div>
      )}
      {sweetSpot && (
        <div className="quick-stats-strip__pill">
          <span className="quick-stats-strip__value">
            {formatCompactPrice(sweetSpot.min)} - {formatCompactPrice(sweetSpot.max)}
          </span>
          <span className="quick-stats-strip__label">Most Demand</span>
        </div>
      )}
    </div>
  );
};

export default QuickStatsStrip;
